import type { $Fetch, FetchOptions } from "ofetch";

class HttpFactory {
  private $fetch: $Fetch;

  constructor(fetcher: $Fetch) {
    this.$fetch = fetcher;
  }

  /**
   * Wrapper para o método GET
   */
  async get<T>(url: string, extras: FetchOptions<"json"> = {}): Promise<T> {
    return await this.$fetch(url, { ...extras, method: "GET" });
  }

  /**
   * Wrapper para o método POST
   */
  async post<T>(
    url: string,
    body?: any,
    extras: FetchOptions<"json"> = {},
  ): Promise<T> {
    return await this.$fetch(url, { ...extras, method: "POST", body });
  }

  /**
   * Wrapper para o método PUT
   */
  async put<T>(
    url: string,
    body?: any,
    extras: FetchOptions<"json"> = {},
  ): Promise<T> {
    return await this.$fetch(url, { ...extras, method: "PUT", body });
  }

  /**
   * Wrapper para o método DELETE
   */
  async patch<T>(
    url: string,
    body?: any,
    extras: FetchOptions<"json"> = {},
  ): Promise<T> {
    return await this.$fetch(url, { ...extras, method: "PATCH", body });
  }

  async delete<T>(url: string, extras: FetchOptions<"json"> = {}): Promise<T> {
    return await this.$fetch(url, { ...extras, method: "DELETE" });
  }
}

export default HttpFactory;
